/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import Backbone from 'backbone';
import _ from 'lodash';
import NProgress from 'nprogress';

import Session from '@/Session';
import Scaffold from '@/Scaffold';
import * as NavUtils from '@/util/NavUtils';
import ErrorView from '@/views/ErrorView';

import CACRegisterPage from '../pages/CACRegisterPage';

export default async function ShowCACRegisterPage() {
  Messenger().hideAll();

  if(Session.user) {
    showErrorView();
    return;
  }

  NProgress.start();
  NavUtils.navigate('cac-register-page');
  Scaffold.getRegion('content').show(new CACRegisterPage());
  NProgress.done();
}

function showErrorView(err) {
  Scaffold.getRegion('content').show(
    new ErrorView({
      model: new Backbone.Model({
        errorMessage: _.isString(err?.message) ? err?.message : 'An Error Occurred',
        errorDetails: 'You are currently logged into an EMS account. Please log out to register a new account.'
      })
    })
  );
}